import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import FixedPlugin from "components/fixedPlugin/FixedPlugin";
import SignInDefault from "views/auth/signIn/SignInDefault";
import { useAuthContext } from "auth/AuthProvider";

export default function Auth() {
  const { isAuthenticated, isLoading, hasFullControl } = useAuthContext();
  document.documentElement.dir = "ltr";

  if (isLoading) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-lightPrimary dark:bg-navy-900">
        <div className="flex flex-col items-center gap-4">
          <div className="border-t-transparent h-12 w-12 animate-spin rounded-full border-4 border-brand-500"></div>
          <p className="text-base font-medium text-navy-700 dark:text-white">
            Loading...
          </p>
        </div>
      </div>
    );
  }

  if (isAuthenticated) {
    const isFullControl = hasFullControl();
    return <Navigate to={isFullControl ? "/dashboard" : "/chat"} replace />;
  }

  return (
    <div>
      <div className="relative float-right h-full min-h-screen w-full dark:!bg-navy-900">
        <main className={`mx-auto min-h-screen`}>
          <Routes>
            <Route path="/sign-in" element={<SignInDefault />} />
            <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}
